import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  'CatalogCourseModalBanner.bannerCatalogText': {
    id: 'CatalogCourseModalBanner.bannerCatalogText',
    defaultMessage: 'Included with subscription',
    description: 'Text for modal subheader banner for catalog inclusion.',
  },
  'CatalogCourseModalBanner.bannerExecEdText': {
    id: 'CatalogCourseModalBanner.bannerExecEdText',
    defaultMessage: 'Executive Education',
    description: 'Text for modal subheader banner for exec ed courses.',
  },
  'CatalogCourseModalBanner.bannerPriceText': {
    id: 'CatalogCourseModalBanner.bannerPriceText',
    defaultMessage: 'A la carte course price',
    description: 'Text for modal subheader banner for a la carte price.',
  },
  'CatalogCourseModalBanner.bannerPriceTextProgram': {
    id: 'CatalogCourseModalBanner.bannerPriceTextProgram',
    defaultMessage: 'A la carte program price',
    description: 'Text for modal subheader banner for a la carte price.',
  },
  'CatalogCourseModalBanner.bannerCourseText': {
    id: 'CatalogCourseModalBanner.bannerCourseText',
    defaultMessage: 'Skill-building selection',
    description: 'Text for modal subheader banner for courses.',
  },
  'CatalogCourseModalBanner.bannerExecEdSubtext': {
    id: 'CatalogCourseModalBanner.bannerExecEdSubtext',
    defaultMessage: 'Immersive, instructor-led course',
    description: 'Text for modal subheader banner for exec ed courses.',
  },
  'CatalogCourseModalBanner.availableNow': {
    id: 'CatalogCourseModalBanner.availableNow',
    defaultMessage: 'Available now',
    description: 'Availability label shown in the course modal banner when the advertised session has already started.',
  },
  'CatalogCourseModalBanner.startingSoon': {
    id: 'CatalogCourseModalBanner.startingSoon',
    defaultMessage: 'Starting soon',
    description: 'Availability label shown in the course modal banner when the advertised session has not started yet.',
  },
});

export default messages;
